// clearance-req.js
// Clearance request functions for running collision results

import { updateCollisionResult } from './clearance-results.js';

export async function runAnalysis(formValues) {
   const sweepOpts = {
      name: 'Collision Sweep',
      description: 'Collision sweep for the vehicle combination',
      yawModes: genSweep({ left: -45, right: 45, step: 5 }),
      pitchModes: [0, -6, 7], // Example pitch mode test range as per MRWA requirements
      rollModes: [0, 15, -15], // Roll angles for the dolly and trailer
      pivotModes: genSweep({ left: -45, right: 45, step: 5 }), // Pivot angles for the dolly and trailer
      exitOnFirstCollision: false,
      saveAllSvg: false,
   };

   // sweepOpts.yawModes = [0, 30, 45]; // For now, only run the 0 degree yaw mode
   // sweepOpts.pitchModes = [0, 5, 7]; // For now, only run the 0 degree pitch mode
   // sweepOpts.rollModes = [0, 15]; // For now, only run the 0 degree roll mode
   // sweepOpts.pivotModes = [0, 30]; // For now, only run the 0 degree pivot mode

   $('#runAnalysisBtn').prop('disabled', true);
   $('#spinnerIcon').removeClass('d-none');
   $('#status').text('Calculating...');

   try {
      const result = await runCollisionResults(formValues, sweepOpts);
      if (result) {
         updateCollisionResult(formValues, result);
         $('#status').text('Done.');
      } else {
         $('#status').text('No result returned.');
      }
   } catch (err) {
      $('#status').text('Failed.');
      console.error(err);
   } finally {
      $('#runAnalysisBtn').prop('disabled', false);
      $('#spinnerIcon').addClass('d-none');
   }
}

function genSweep({ left, right, step }) {
   const yawLeft = [];
   for (let yaw = 0; yaw >= left; yaw -= step) yawLeft.push(yaw);
   const yawRight = [];
   for (let yaw = step; yaw <= right; yaw += step) yawRight.push(yaw);
   return [...yawLeft, ...yawRight];
}

/* Run the collision results for the current form values.
 * Returns a promise that resolves with the results.
 */
export async function runCollisionResults(formValues, sweepOpts, singleSweepOpts = false) {
   try {
      const response = await $.ajax({
         url: '/api/run-sweep',
         method: 'POST',
         contentType: 'application/json',
         data: JSON.stringify({ formValues, sweepOpts, singleSweepOpts }),
      });

      return response;
   } catch (error) {
      console.error('Error running collision sweep:', error);
      $('#collisionResults').html('<p class="text-danger">Error running collision sweep.</p>');
      return null;
   }
}
